/* RESPONSIBLE TEAM: team-reporting */
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import {
  buildChartContextItem,
  type ContextItem,
} from 'embercom/lib/reporting/custom/chart-context-serializer';
import type ReactTeammateAppIslandService from 'embercom/services/react-teammate-app-island';

const MAX_CHART_CONTEXTS = 5;

export default class ReportingAgentSidebarService extends Service {
  @service declare reactTeammateAppIsland: ReactTeammateAppIslandService;

  @tracked isOpen = false;
  @tracked chartContexts: ContextItem[] = [];

  private unsubscribers: Array<() => void> = [];

  init() {
    super.init();
    this.unsubscribers.push(
      this.reactTeammateAppIsland.subscribeToTeammateAppEvent('reporting-agent:close-sidebar', () =>
        this.close(),
      ),
      this.reactTeammateAppIsland.subscribeToTeammateAppEvent(
        'reporting-agent:remove-chart',
        (data: Record<string, unknown>) => {
          let index = data['index'] as number;
          this.removeChart(index);
        },
      ),
    );
  }

  willDestroy() {
    super.willDestroy();
    this.unsubscribers.forEach((unsub) => unsub());
  }

  get serializedChartContexts(): string {
    return JSON.stringify(this.chartContexts);
  }

  openWithChart(chart: any, reportState: any) {
    let item = buildChartContextItem(chart, reportState);
    this.chartContexts = [item];
    this.isOpen = true;
  }

  addChart(chart: any, reportState: any) {
    if (this.chartContexts.length >= MAX_CHART_CONTEXTS) {
      return;
    }
    let item = buildChartContextItem(chart, reportState);
    this.chartContexts = [...this.chartContexts, item];
    this.reactTeammateAppIsland.dispatchTeammateAppEvent('reporting-agent:add-chart', {
      chart: item,
    });
  }

  removeChart(index: number) {
    this.chartContexts = this.chartContexts.filter((_, i) => i !== index);
    if (this.chartContexts.length === 0) {
      this.close();
    }
  }

  close() {
    this.isOpen = false;
    this.chartContexts = [];
  }
}

declare module '@ember/service' {
  interface Registry {
    'reporting-agent-sidebar': ReportingAgentSidebarService;
    reportingAgentSidebar: ReportingAgentSidebarService;
  }
}
